export function fullwidth_to_halfwidth(str) {
  if(typeof str != 'string') return str;
  while(/[\uff01-\uff5e]/.test(str)) {
    let match = str.match(/[\uff01-\uff5e]/);
    if(!match) continue;
    let target_code = match[0].charCodeAt(0) - 65248;
    let target_char = String.fromCharCode(target_code);
    str = str.split(match[0]).join(target_char);
  }
  return str;
}

export function halfwidth_to_fullwidth(str) {
  if(typeof str != 'string') return str;
  while(/[\u0021-\u007e]/.test(str)) {
    let match = str.match(/[\u0021-\u007e]/);
    if(!match) continue;
    let target_code = match[0].charCodeAt(0) + 65248;
    let target_char = String.fromCharCode(target_code);
    str = str.split(match[0]).join(target_char);
  }
  return str;
}
